import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  fetchScreen,
  hideFeedbackCardForFeature,
  IFeedback,
  IFeedback200,
  sendFeedback,
  sendFeedback200,
} from './feedback-data.actions';
import { FeedbackScreenEnum } from './feedback-data.data';

@Injectable()
export class FeedbackDataDispatcher {
  constructor(private _store: Store<any>) {}

  fetchScreen(screenId: FeedbackScreenEnum) {
    this._store.dispatch(fetchScreen(screenId));
  }

  sendFeedback(feedback: IFeedback) {
    this._store.dispatch(sendFeedback(feedback));
  }

  sendFeedback200(feedback: IFeedback200) {
    this._store.dispatch(sendFeedback200(feedback));
  }

  hideFeedbackCardForAccount(featureName: string, accountId: string) {
    this._store.dispatch(hideFeedbackCardForFeature(featureName, accountId));
  }
}
